import React, { forwardRef, PropsWithChildren } from 'react';
import Container from './Container';

type Props = {
  componentKey: string;
  componentInstanceKey: string;
  properties?: {
    vertical_margin?: string;
    horizontal_margin?: string;
    background?: string;
  };
  className?: string;
  style?: React.CSSProperties;
};

const DataSourceEmpty = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ componentKey, componentInstanceKey, properties, children }, ref) => {
    return <></>;
  }
);

export default DataSourceEmpty;
